import {memo} from "react";
import { StyledDivider } from './Divider.styles';

const Divider = (props : {height: number}) => {
    return (
        <StyledDivider height={props.height}/>
    );
}

export default memo(Divider);